import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../setup/store';

export interface RioUserProfile {
    sub?: string;
    azp?: string;
    account?: string;
    givenName?: string;
    familyName?: string;
    name?: string;
    locale?: string;
    email?: string;
    tenant?: string;
}

export interface LoginState {
    hasUserSessionEverExpired: boolean;
    userProfile: RioUserProfile | null;
    userSessionExpired: boolean;
    wasLoggedInBefore: boolean;
}

const initialState: LoginState = {
    hasUserSessionEverExpired: false,
    userProfile: null,
    userSessionExpired: false,
    wasLoggedInBefore: false,
};

export const loginSlice = createSlice({
    name: 'login',
    initialState: initialState,
    reducers: {
        userProfileObtained: (state, action: PayloadAction<RioUserProfile>) => {
            state.userProfile = action.payload;
        },
        userSessionExpired: state => {
            state.hasUserSessionEverExpired = true;
            state.userSessionExpired = true;
        },
        userSessionRenewed: state => {
            state.userSessionExpired = false;
        },
        setWasLoggedInBefore: (state, action: PayloadAction<boolean>) => {
            state.wasLoggedInBefore = action.payload;
        },
    },
});

export const { userProfileObtained, userSessionExpired, userSessionRenewed, setWasLoggedInBefore } = loginSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const getUserProfile = (state: RootState) => state.login?.userProfile;
export const getUserAccount = (state: RootState) => state.login?.userProfile?.account;

export const hasUserSessionEverExpired = (state: RootState) => state.login?.hasUserSessionEverExpired;
export const isUserSessionExpired = (state: RootState) => state.login?.userSessionExpired;
export const getWasLoggedInBefore = (state: RootState) => state.login.wasLoggedInBefore;

export default loginSlice.reducer;
